"use strict";
/**
 * Created by Pankaj on 2019-12-20.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPanelLabelIDs = void 0;
var PromoPanelLabelIDs;
(function (PromoPanelLabelIDs) {
    PromoPanelLabelIDs["PROMO_PANEL_HEADING"] = "NOLIMIT";
    PromoPanelLabelIDs["PROMO_PANEL_PROMOTIONS_HEADING"] = "PROMOTIONS";
    PromoPanelLabelIDs["BET"] = "Bet";
    PromoPanelLabelIDs["BUY"] = "BUY";
    PromoPanelLabelIDs["BUY_FEATURE_TITLE"] = "Nolimit Shortcut";
    PromoPanelLabelIDs["BUY_FEATURE_COST"] = "COST";
    //POPUP
    PromoPanelLabelIDs["POPUP_CANCEL"] = "CANCEL";
    PromoPanelLabelIDs["POPUP_OK"] = "OK";
    PromoPanelLabelIDs["CHARGE_FROM_WALLET"] = "will be charged from your wallet";
    //REPLAY
    PromoPanelLabelIDs["REPLAY_FEATURE_TITLE"] = "Nolimit Winners";
    PromoPanelLabelIDs["REPLAY_CURRENT_GAME"] = "Current game";
    PromoPanelLabelIDs["REPLAY_ALL_GAMES"] = "All games";
    PromoPanelLabelIDs["REPLAY_X_BET"] = "Bet";
    PromoPanelLabelIDs["REPLAY_X_WIN"] = "Win";
    PromoPanelLabelIDs["REPLAY_TOP_WINS_HEADING"] = "OVERALL TOP WINS";
    PromoPanelLabelIDs["REPLAY_MY_TOP_WINS_HEADING"] = "MY TOP WINS";
    // Action Spins
    PromoPanelLabelIDs["ACTION_SPINS"] = "Nolimit Action Spins";
    PromoPanelLabelIDs["ACTION_SPINS_COST"] = "Action Spins Cost";
    PromoPanelLabelIDs["ROUNDS"] = "Rounds";
    PromoPanelLabelIDs["PRESS_S_TO_STOP"] = "Press S to stop";
    PromoPanelLabelIDs["SPINS_LEFT"] = "Spins Left :";
    PromoPanelLabelIDs["FREE_SPINS_LEFT"] = "FS Left :";
    PromoPanelLabelIDs["SETTING"] = "Settings";
    PromoPanelLabelIDs["BONUS_BUY"] = "Bonus Buy";
    PromoPanelLabelIDs["ACTION_SPINS_BONUS_BUY"] = "Action Spins Bonus Buy";
    PromoPanelLabelIDs["ACTION_SPINS_BONUS_BUY_LABEL"] = "Nolimit Bonus";
    PromoPanelLabelIDs["ACTION_SPINS_MAIN_GAME_LABEL"] = "Main Game";
    PromoPanelLabelIDs["YES"] = "YES";
    PromoPanelLabelIDs["STOP_ON_BONUS"] = "Stop on bonus";
    PromoPanelLabelIDs["PLAY_BONUS_IN_GAME"] = "Play bonus in game";
    //Nolimit voucher
    PromoPanelLabelIDs["NOLIMIT_VOUCHER"] = "Nolimit Promotions";
    PromoPanelLabelIDs["TICKET_VALUE"] = "VALUE";
    // Action Spins End Texts
    PromoPanelLabelIDs["NUMBER_OF_ROUNDS"] = "Number of Rounds";
    PromoPanelLabelIDs["TOTAL_WIN"] = "Total Win";
    PromoPanelLabelIDs["TOTAL_BET_PLACED"] = "Total bet Placed";
    PromoPanelLabelIDs["TOTAL_FS_TRIGGERED"] = "Total Fs Triggered";
    PromoPanelLabelIDs["START"] = "START";
    PromoPanelLabelIDs["TOTAL_COST"] = "TOTAL COST";
    PromoPanelLabelIDs["CONTINUE"] = "Continue";
    PromoPanelLabelIDs["AS_SETTING_MAX_WIN_TEXT"] = "Max Win";
})(PromoPanelLabelIDs = exports.PromoPanelLabelIDs || (exports.PromoPanelLabelIDs = {}));
//# sourceMappingURL=PromoPanelLabelIDs.js.map